export default "<div class=\"divider\">\n  <div class=\"separator-line\"></div>\n  <div class=\"data\">{{ content }}</div>\n</div>\n"